export default {
  "meta": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NARS"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])}
  },
  "hero": {
    "loader": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("progress")), "%"])},
    "scroller": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scroll to Explore"])}
  },
  "stack": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A simple childhood in tarbes."])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["France is renowned for its rich cultural heritage and sense of aesthetics, and growing up in a small town in France has shaped François' artistic sensibility and authenticity."])}
  },
  "next": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next Chapter"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tap to continue"])}
  },
  "products": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View product page"])}
  },
  "carousel": {
    "slide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slide to view"])},
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop now"])},
    "learn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Learn more"])}
  },
  "text": {
    "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View more"])}
  },
  "chapter-1": {
    "slice-0": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-0_image.png"])}
      }
    },
    "slice-1": {
      "youtube": {
        "desktop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2uKUUR6ZDqM"])},
        "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W5SCFeqkyxg"])}
      },
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-1_image.jpg"])}
      }
    },
    "slice-2": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-2_image-1.jpg"])}
      }
    },
    "slice-3": {
      "item-1": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-1.jpg"])}
        }
      },
      "item-2": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-2.jpg"])}
        }
      },
      "item-3": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-3.jpg"])}
        }
      },
      "item-4": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-4.jpg"])}
        }
      },
      "item-5": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-3_image-5.jpg"])}
        }
      }
    },
    "slice-4": {
      "item-1": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-1.jpg"])}
        }
      },
      "item-2": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-2.jpg"])}
        }
      },
      "item-3": {
        "image": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_slice-4_image-3.jpg"])}
        }
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-1_next.jpg"])}
      }
    }
  },
  "chapter-2": {
    "slice-1": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-1_image-5.jpg"])}
      }
    },
    "slice-2": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-2_image-3.jpg"])}
      }
    },
    "slice-3": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-4_image-6.jpg"])}
      }
    },
    "slice-5": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_slice-5_image-5.jpg"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-2_next.jpg"])}
      }
    }
  },
  "chapter-3": {
    "slice-1": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-1_image-4.jpg"])}
      }
    },
    "slice-2": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-6.jpg"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-7.jpg"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-8.jpg"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-9.jpg"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-2_image-10.jpg"])}
      }
    },
    "slice-3": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-3_image-1.jpg"])}
      }
    },
    "slice-4": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_slice-4_image-5.jpg"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-3_next.jpg"])}
      }
    }
  },
  "chapter-4": {
    "slice-2": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-2_image-6.jpg"])}
      }
    },
    "slice-3": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-6.jpg"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-7.jpg"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-3_image-8.jpg"])}
      }
    },
    "slice-4": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-4_image-5.jpg"])}
      }
    },
    "slice-5": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-5_image-6.jpg"])}
      }
    },
    "slice-6": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-6.jpg"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-7.jpg"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-8.jpg"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-9.jpg"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-10.jpg"])}
      },
      "image-11": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-6-image-11.jpg"])}
      }
    },
    "slice-7": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-7_image-4.jpg"])}
      }
    },
    "slice-8": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-8_image-4.jpg"])}
      }
    },
    "slice-9": {
      "image-1": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-1.jpg"])}
      },
      "image-2": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-2.jpg"])}
      },
      "image-3": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-3.jpg"])}
      },
      "image-4": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-4.jpg"])}
      },
      "image-5": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-5.jpg"])}
      },
      "image-6": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-6.jpg"])}
      },
      "image-7": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-7.jpg"])}
      },
      "image-8": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-8.jpg"])}
      },
      "image-9": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-9.jpg"])}
      },
      "image-10": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_slice-9-image-10.jpg"])}
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-4_next_image.jpg"])}
      }
    }
  },
  "chapter-5": {
    "slice-1": {
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-4.jpg"])}
        }
      },
      "image-5": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-1_visual-5.jpg"])}
        }
      }
    },
    "slice-2": {
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-2_visual-4.jpg"])}
        }
      }
    },
    "slice-3": {
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-3_visual-4.jpg"])}
        }
      }
    },
    "slice-4": {
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-4_visual-4.jpg"])}
        }
      }
    },
    "slice-5": {
      "image-1": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-1.jpg"])}
        }
      },
      "image-2": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-2.jpg"])}
        }
      },
      "image-3": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-3.jpg"])}
        }
      },
      "image-4": {
        "full": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        },
        "thumbnail": {
          "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_slice-5_visual-4.jpg"])}
        }
      }
    },
    "next": {
      "image": {
        "src": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["chapter-5_next.jpg"])}
      }
    }
  }
}